import React, { Component } from 'react';
import Loader from 'react-loader';
import scrollToElement from 'scroll-to-element';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import {loadCsrf} from '../common/CsrfFetcher';
import SelectType from './SelectType';
import Individual from './Individual';
import IndividualToS from './IndividualToS';
import Corporate from './Corporate';
import CorporateToS from './CorporateToS';
import Confirmation from './Confirmation';
import {RouteNotFound404} from '../RouteNotFound404';
import validateOrgName from '../helper/validateOrgName';
import validateName from '../helper/validateName';
import validateEmail from '../helper/validateEmail';
import validatePassword from '../helper/validatePassword';
import validatePhone from '../helper/validatePhoneNumber';
import validateAddress from '../helper/validateAddress';
import validateCity from '../helper/validateCity';
import validateZipcode from '../helper/validateZipcode';
import validateCaptcha from '../helper/validateCaptcha';
import validateUSState from '../helper/validateUSState';
import validateNonUSState from '../helper/validateNonUSState';


class RegistrationRouter extends Component {

  constructor (props) {
      super(props);
      var hostApiUrl = process.env.REACT_APP_HOST_API_URL;

      this.state = {

    	  /* New Individual Account */
          firstName: {value:'', isValid: '', message:'', hasErrorFocus: false},
          lastName: {value:'', isValid: '', message:'', hasErrorFocus: false},
          email: {value:'', isValid: '', message:'', hasErrorFocus: false},
          password: {value:'', isValid: '', message:'', hasErrorFocus: false},
          phoneNumber: {value:'', isValid: '', message:'', hasErrorFocus: false},
          address1: {value:'', isValid: '', message:'', hasErrorFocus: false},
          country: {value:'', isValid: '', message:''},
          stateProvince: {value:'', isValid: '', message:'' },
          nonUSState: {value:'', isValid: '', message:''},
          city: {value:'', isValid: '', message:'', hasErrorFocus: false},
          postalCode: {value:'', isValid: '', message:'', hasErrorFocus: false},
          newsletterSubscription: {value:true, isValid: '', message:''},
          eventsSubscription: {value:true, isValid: '', message:''},
          captcha: {value:'', isValid:'', message:'', image: hostApiUrl + '/developer/mvc/captcha/image?v='+ Date.now() },
          questionAndAnswerFirstResponderQuestion: "Are you a first responder?",
          questionAndAnswerFirstResponderPossibleAnswers: ["Yes, I am", "No, I am not"],
          questionAndAnswerFirstResponderAnswers: [],
          questionAndAnswerContributionsQuestion: "What will you make available through the FirstNet Developer Program?",
          questionAndAnswerContributionsPossibleOptions: ["APIs", "Apps", "Other resources"],
          questionAndAnswerContributionsSelectedOptions: [],

          /* New Corporate Account */
          orgName: {value:'', isValid: '', message:'', hasErrorFocus: false, isAvailable:''},
          questionAndAnswerOrganizationTypeLabel: "Organization Type",
          questionAndAnswerOrganizationTypes: ["Public Safety Agency", "Technology Company", "Educational Organization", "Other Organization"],
          questionAndAnswerOrganizationTypeSelected: [],

          /* Generic Variables for both accounts */
          csrfToken: '',
          csrfTokenHeaderName:'',
          genericFormLevelProblems:'',
          isCreateUserSubmitted: false,
          userCreationSucceeded:false,
          showLoader: false
      }
  }

    componentDidMount() {
        loadCsrf(this.setCsrfState);
    }

    setCsrfState = (csrfToken, csrfHeaderValue) => {
        var state = this.state;
        state.csrfToken = csrfToken;
        state.csrfTokenHeaderName = csrfHeaderValue;
        this.setState({
          state
        });
    }

    checkIfOrgNameValidAndAvailableEvent = (e) => {
        const value = e.target.value;
        const name = e.target.name;
        var state = this.state;
        this.checkIfOrgNameValidAndAvailableToContinue(name, value, state);
    }

    checkIfOrgNameValidAndAvailableToContinue = (fieldName, value, state) => {
        const name = fieldName;
        if(state[name].isValid) {
        	 this.setState({
                 showLoader: true
             })
            fetch(process.env.REACT_APP_HOST_API_URL + "/developer/mvc/api/organizations/nameAvailable?orgType=FIRST_NET&name="+this.state.orgName.value, {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                credentials: 'include',
                method: 'GET'
              })
              .then(response=> {
                if (!response.ok) {
                  console.log("response is not ok " + response.statusText  + " with status of " + response.status);
                  if(response.status === 409){
                      return response.json();
                  }

                  throw new Error("Unknown Problem occurred : " + response.statusText);
                }

              })
              .then(json => {
                  if(json) {
                	  if(json.errorCode === 'OrganziationNameAlreadyTakenException') {
                		  console.log("text of body is " + json.message);
	                      state.orgName.isValid = false;
                          state.orgName.message = "Error: Please try different Organization name";
                          state.orgName.isAvailable = false;
                          console.log("early state :::: " + state.orgName.message);
                	  }
                	  else {
                        this.setState({
                            genericFormLevelProblems:['Error: ' + json.message]
                        });
                      }
                    this.setState({
                        showLoader: false
                    })
                    this.setErrorFocus(state);
                    this.scrollToError(state);
                  }
                  else {

                        state.orgName.isValid = true;
                        state.orgName.message = '';
                        state.orgName.isAvailable = true;
                        const isValidToContinue = state.firstName.isValid &&
                                                    state.lastName.isValid &&
                                                    state.email.isValid &&
                                                    state.password.isValid &&
                                                    state.orgName.isValid &&
                                                    state.orgName.isAvailable;
                        this.setState({
                            showLoader: false
                        })
                       return isValidToContinue;

                   }
                  this.setState({
                    state
                  });
              })
              .catch(error => {
                  console.log("Uh oh.... didn't work " + error.message);
                  //window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=request.processing.error";
                  return Promise.reject();
              });


              this.setState({
                state
              });

              return state.orgName.isValid && state.orgName.isAvailable;
        }
    }

    handleUserInput = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        var state = this.state;
        state.genericFormLevelProblems='';
        if(name === 'newsletterSubscription' || name === 'eventsSubscription'){
            if(e.target.checked){
                state[name].value = true;
            }
            else{
                state[name].value = false;
            }
        }
        else if (name.includes('questionAndAnswer')){
            this.handleQandA(e, state);
        }
        else{
          state[name].value = e.target.value;
        }
        if(name === 'email'){
            state[name].value = value.toLowerCase();
        }
        this.setState(state,
                    () => { this.validateField(name, value) });
    }

    handleQandA = (e, state) =>{
        const name = e.target.name;
        const answer = e.target.value;
        const isChecked = e.target.checked;

        var answers = state[name];
        if((isChecked && e.target.type === 'radio') || (e.target.type === 'select-one') ){
            answers = [];
            answers.push(answer);
        }
        else if (isChecked){
            answers.push(answer);
        }
        else{
            //remove unchecked
            answers = answers.filter(answerLocal => answerLocal !== answer);
        }
        state[name] = answers;
        this.setState({state});
    }

    handleAlignErrors = (location, json) =>{
        var state = this.state;

        const field = json.validationErrors[location].field;
        const errorCode = json.validationErrors[location].errorCode;

        if(field === 'phoneNumber' && errorCode === "Pattern")	{
            state[field].isValid = false;
            state[field].message = 'Error: Please enter a valid Phone Number.';
        } else if(field === 'address1' && errorCode === "Pattern")	{
            state[field].isValid = false;
            state[field].message = 'Error: Please enter a valid Address';
        } else if(field === 'city' && errorCode === "Pattern")	{
            state[field].isValid = false;
            state[field].message = 'Error: Please enter a valid City';
        } else if(field === 'postalCode' && errorCode === "Pattern")	{
            state[field].isValid = false;
            state[field].message = 'Error: Please enter a valid Zip / Postal Code.';
        }
        else {
            state[field].isValid=false;
            state[field].message="Well, something went wrong with this field... ";
       }
       this.setState({state});
    }

    handleReconcileCountryState = () =>{
        //Don't want to submit a state if it is not the USA.
        var state = this.state;
        if(this.state.country.value === "UNITED STATES"){
            state['nonUSState'].value = '';
        }
        else{
            this.validateNonUSStateResponse('nonUSState', this.state.nonUSState.value, state);
            state['stateProvince'].value = '';
        }

        this.setState({state});
    }

    handleSubmitIndividualUser = (event) =>{

        event.preventDefault();

        //just validate the existing page to show any errors
        this.handleReconcileCountryState();
        const isValidToContinue = this.handleValidationTermsOfService(event);
        console.log("isValidToContinue ..........." + isValidToContinue);
        if(!isValidToContinue){
            return;
        }

        //TODO: Validate all the form information here?
        var isFormValid = true;

        if(isFormValid) {

            //combine questions :
            let combinedQuestionsAndAnswersMap  = new Map();
            if(Array.isArray(this.state.questionAndAnswerFirstResponderAnswers) || this.state.questionsAndAnswerFirstResponderAnswers.length>0){
                combinedQuestionsAndAnswersMap.set(this.state.questionAndAnswerFirstResponderQuestion, this.state.questionAndAnswerFirstResponderAnswers);
            }

            if(Array.isArray(this.state.questionAndAnswerContributionsSelectedOptions) || this.state.questionAndAnswerContributionsSelectedOptions.length>0){
                combinedQuestionsAndAnswersMap.set(this.state.questionAndAnswerContributionsQuestion, this.state.questionAndAnswerContributionsSelectedOptions);
            }

            let qAndAObjectFromMap = Array.from(combinedQuestionsAndAnswersMap).reduce((obj, [key, value]) => (
                Object.assign(obj, { [key]: value }) // Be careful! Maps can have non-String keys; object literals can't.
            ), {});

            var csrfToken = this.state.csrfToken;
            var usersData = {
                "firstName": this.state.firstName.value,
                "lastName": this.state.lastName.value,
                "email": this.state.email.value,
                "password": this.state.password.value,
                "termsAndConditions": "true",
                "phoneNumber": this.state.phoneNumber.value,
                "address1": this.state.address1.value,
                "city": this.state.city.value,
                "state": this.state.stateProvince.value,
                "nonUSStateProvince": this.state.nonUSState.value,
                "country": this.state.country.value,
                "postalCode": this.state.postalCode.value,
                "newsletter": this.state.newsletterSubscription.value,
                "specialEvents": this.state.eventsSubscription.value,
                "genericQuestionsAndAnswers": qAndAObjectFromMap
            };

            this.setState({
                isCreateUserSubmitted:true
            });

            fetch(process.env.REACT_APP_HOST_API_URL + "/developer/mvc/api/registration?captchaAnswer=" + this.state.captcha.value, {
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
                },
                credentials: 'include',
                method: 'POST',
                body: JSON.stringify(usersData)
            })
            .then(response=> {
                if (!response.ok) {
                    console.log("response is not ok " + response.statusText  + " with status of " + response.status);

                    if(response.status === 400 || response.status === 409){
                        return response.json();
                    }
                    throw new Error("Unknown Problem occurred : " + response.statusText);
                }
            })
            .then(json=>{
                console.log("Now processing JSON");
                this.setState({
                    isCreateUserSubmitted:false
                });

                if(json){

                	this.refreshCaptcha();

                    if(json.errorCode === 'CaptchaInvalidException'){
                        var state = this.state;
                        state['captcha'].isValid = false;
                        state['captcha'].message = "Error: Please enter the text in the captcha image.";

                        this.setState({state});

                    } else if(json.errorCode === 'FirstNetUserAlreadyExistsException'){
                            this.setState({
                                email: {isValid: false, value: this.state.email.value, message:'Error: ' + json.message, hasErrorFocus: true}
                            });
                    } else {
                        for(var i =0; i<json.validationErrors.length; i++){
                            this.handleAlignErrors(i, json);
                        }

                        this.setState({
                            genericFormLevelProblems:['Error: Something went wrong, please correct any issues and try again.']
                        });
                    }
                }
                else{
                    //returning nothing means 200 response and send to Confirmation Page.
                    console.log("User creation succeeded");
                    this.setState({
                        userCreationSucceeded:true
                    });

                }
            })
            .catch(error => {
                console.log("Uh oh.... didn't work " + error.message);
                window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=request.processing.error";
                return Promise.reject();
            });
        }
        else {
            console.log("form is not valid.... will not submit");
            this.setState({
                genericFormLevelProblems:['Error: Please correct any incorrect entries before you submit.']
            });
        }
    }

    handleSubmitCorporateUser = (event) =>{

        event.preventDefault();

        //just validate the existing page to show any errors
        this.handleReconcileCountryState();
        const isValidToContinue = this.handleValidationTermsOfService(event);
        console.log("isValidToContinue ..........." + isValidToContinue);
        if(!isValidToContinue){
            return;
        }

        //TODO: Validate all the form information here?
        var isFormValid = true;

        if(isFormValid){
         // qAndAObject = Object.create(null);
         // map.forEach((value, key) =>{
         //     if(value instanceof)
         // })

         //combine questions :
         let combinedQuestionsAndAnswersMap  = new Map();
         if(Array.isArray(this.state.questionAndAnswerFirstResponderAnswers) || this.state.questionAndAnswerFirstResponderAnswers.length>0){
             combinedQuestionsAndAnswersMap.set(this.state.questionAndAnswerFirstResponderQuestion, this.state.questionAndAnswerFirstResponderAnswers);
         }

         if(Array.isArray(this.state.questionAndAnswerContributionsSelectedOptions) || this.state.questionAndAnswerContributionsSelectedOptions.length>0){
             combinedQuestionsAndAnswersMap.set(this.state.questionAndAnswerContributionsQuestion, this.state.questionAndAnswerContributionsSelectedOptions);
         }


         let qAndAObjectFromMap = Array.from(combinedQuestionsAndAnswersMap).reduce((obj, [key, value]) => (
             Object.assign(obj, { [key]: value }) // Be careful! Maps can have non-String keys; object literals can't.
                            ), {});

         //combine questions for ORG :
         let combinedQuestionsAndAnswersOrgMap  = new Map();
         if(Array.isArray(this.state.questionAndAnswerOrganizationTypeSelected) || this.state.questionAndAnswerOrganizationTypeSelected.length>0){
        	 combinedQuestionsAndAnswersOrgMap.set(this.state.questionAndAnswerOrganizationTypeLabel, this.state.questionAndAnswerOrganizationTypeSelected);
         }

         let qAndAOrgObjectFromMap = Array.from(combinedQuestionsAndAnswersOrgMap).reduce((obj, [key, value]) => (
                 Object.assign(obj, { [key]: value }) // Be careful! Maps can have non-String keys; object literals can't.
                                ), {});

          const csrfToken = this.state.csrfToken;
          var usersData = {
        	  "name": this.state.orgName.value,
              "firstName": this.state.firstName.value,
              "lastName": this.state.lastName.value,
              "email": this.state.email.value,
              "password": this.state.password.value,
              "termsAndConditions": "true",
              "phoneNumber": this.state.phoneNumber.value,
              "address1": this.state.address1.value,
              "city": this.state.city.value,
              "state": this.state.stateProvince.value,
              "nonUSStateProvince": this.state.nonUSState.value,
              "country": this.state.country.value,
              "postalCode": this.state.postalCode.value,
              "newsletter": this.state.newsletterSubscription.value,
              "specialEvents": this.state.eventsSubscription.value,
              "genericQuestionsAndAnswers": qAndAObjectFromMap,
              "genericQuestionsAndAnswersOrganization": qAndAOrgObjectFromMap
          };

        this.setState({
            isCreateUserSubmitted:true
        });

          fetch(process.env.REACT_APP_HOST_API_URL + "/developer/mvc/api/registration?captchaAnswer=" + this.state.captcha.value, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': csrfToken
            },
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify(usersData)
          })
          .then(response=> {
            if (!response.ok) {
              console.log("response is not ok " + response.statusText  + " with status of " + response.status);

              if(response.status === 400 || response.status === 409){
                return response.json();
              }
              throw new Error("Unknown Problem occurred : " + response.statusText);
            }
          })
          .then(json=>{
            console.log("Now processing JSON");
            this.setState({
                isCreateUserSubmitted: false
            });

            if(json){
            	
            	this.refreshCaptcha();
            	
              if(json.errorCode === 'CaptchaInvalidException'){
                  var state = this.state;
                  state['captcha'].isValid = false;
                  state['captcha'].message = "Error: Please enter the text in the captcha image.";


                this.setState({state});

              } else if(json.errorCode === 'FirstNetUserAlreadyExistsException'){
                    this.setState({
                      email: {isValid: false, value: this.state.email.value, message:'Error: ' + json.message, hasErrorFocus: true}
                    });
              } else {
                  for(var i =0; i<json.validationErrors.length; i++){
                      this.handleAlignErrors(i, json);
                  }

                this.setState({
                    genericFormLevelProblems:['Error: Something went wrong, please correct any issues and try again.']
                });
              }
            }
            else{
                //returning nothing means 200 response and send to Confirmation Page.
                console.log("User creation succeeded");
                this.setState({
                    userCreationSucceeded: true
                });
            }
          })
          .catch(error => {
              console.log("Uh oh.... didn't work " + error.message);
              window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=request.processing.error";
              return Promise.reject();
          });
        }
        else {
            this.setState({
                genericFormLevelProblems:['Error: Please correct any incorrect entries before you submit.']
            });
        }
    }

    validateField = (fieldName, value) => {

      var state = this.state;

      if(fieldName ==='orgName'){
          console.log('validateOrgNameResponse will be called now');
          this.validateOrgNameResponse(fieldName, value, state);
      }

      if(fieldName ==='questionAndAnswerOrganizationTypeSelected') {
          this.validateOrgType(fieldName, value, state);
      }

      if(fieldName ==='firstName') {
        this.validateNameResponse(fieldName,value, state);
      }

      if(fieldName === 'lastName') {
          this.validateNameResponse(fieldName, value, state);
      }

      if(fieldName === 'email') {
    	  this.validateEmailSyntaxResponse(fieldName,value, state);
      }

      if(fieldName === 'password') {
          this.validatePasswordResponse(fieldName, value, state);
      }

      if(fieldName === 'phoneNumber') {
          this.validatePhoneResponse(fieldName, value, state);
      }

      if(fieldName ==='address1') {
          this.validateAddressResponse(fieldName, value, state);
      }

      if(fieldName ==='city') {
          this.validateCityResponse(fieldName, value, state);
      }

      if(fieldName ==='postalCode') {
          this.validateZipcodeResponse(fieldName, value, state);
      }

      if(fieldName ==='captcha') {
          this.validateCaptchaResponse(fieldName, value, state);
      }

        if(fieldName ==='stateProvince') {
            this.validateUSStateResponse(fieldName, value, state);
        }

        if(fieldName ==='nonUSState') {
            this.validateNonUSStateResponse(fieldName, value, state);
        }

      this.setState(state);
    }

    validateOrgType = (fieldName, value, state) => {
        if(value === ''){
            state[fieldName].isValid = false;
            state[fieldName].message = "Error: Please enter your Organization Type.";
        }
        else {
            state[fieldName].isValid = true;
            state[fieldName].message = "";
        }
        this.setState({
            state
        });
    }

    validateOrgSuccess = (fieldName, state) => {
		const orgTypeSelect = document.querySelector(".orgTypeSelect");
		if (orgTypeSelect.classList.contains("has-success")) {
			state[fieldName].isValid = true;
            state[fieldName].message = "";
		}
		else {
			state[fieldName].isValid = false;
	        state[fieldName].message = "Error: Please enter your Organization Type.";
		}
		this.setState({
	           state
	    });
    }

    /******Helper Validations*******/
    validateOrgNameResponse = (fieldName, value, state) => {
        const validateOrgNameData = validateOrgName(value, state);
        state[fieldName].isValid = validateOrgNameData.isValid;
        state[fieldName].message = validateOrgNameData.message;
    }

    //Validate First Name / Last Name
    validateNameResponse = (fieldName, value, state) => {
        const validateNameData = validateName(fieldName, value, state);
        state[fieldName].isValid = validateNameData.isValid;
        state[fieldName].message = validateNameData.message;
    }

    validatePhoneResponse = (fieldName, value, state) => {
        const validatePhoneData = validatePhone(value, state);
        state[fieldName].isValid = validatePhoneData.isValid;
        state[fieldName].message = validatePhoneData.message;
    }

    validateEmailSyntaxResponse = (fieldName, value, state) => {
        const validateEmailData = validateEmail(value, state);
        state[fieldName].isValid = validateEmailData.isValid;
        state[fieldName].message = validateEmailData.message;
    }

    validatePasswordResponse = (fieldName, value, state) => {
        const validatePasswordData = validatePassword(value, state);
        state[fieldName].isValid = validatePasswordData.isValid;
        state[fieldName].message = validatePasswordData.message;
    }

    validatePhoneResponse = (fieldName, value, state) => {
        const validatePhoneData = validatePhone(value, state);
        state[fieldName].isValid = validatePhoneData.isValid;
        state[fieldName].message = validatePhoneData.message;
    }

    validateAddressResponse = (fieldName, value, state) => {
        const validateAddressData = validateAddress(value, state);
        state[fieldName].isValid = validateAddressData.isValid;
        state[fieldName].message = validateAddressData.message;
    }

    validateCityResponse = (fieldName, value, state) => {
        const validateCityData = validateCity(value, state);
        state[fieldName].isValid = validateCityData.isValid;
        state[fieldName].message = validateCityData.message;
    }

    validateZipcodeResponse = (fieldName, value, state) => {
        const validateZipcodeData = validateZipcode(value, state);
        state[fieldName].isValid = validateZipcodeData.isValid;
        state[fieldName].message = validateZipcodeData.message;
    }

    validateCaptchaResponse = (fieldName, value, state) => {
        const validateCaptchaData = validateCaptcha(value, state);
        state[fieldName].isValid = validateCaptchaData.isValid;
        state[fieldName].message = validateCaptchaData.message;
    }

    validateNonUSStateResponse = (fieldName, value, state) => {
        const validateNonUSStateData = validateNonUSState(value, state);
        state[fieldName].isValid = validateNonUSStateData.isValid;
        state[fieldName].message = validateNonUSStateData.message;
    }

    validateUSStateResponse = (fieldName, value, state) => {
        const validateUSStateData = validateUSState(value, state);
        state[fieldName].isValid = validateUSStateData.isValid;
        state[fieldName].message = validateUSStateData.message;
    }

    showUSStatesDropdown = () => {
        if(this.state.country.value === 'Select' || this.state.country.value === 'UNITED STATES' || this.state.country.value === '') {
            return true;
        } else {
            return false;
        }
    }

    refreshCaptcha = () => {
        let captcha = this.state.captcha;
        captcha.image = process.env.REACT_APP_HOST_API_URL + '/developer/mvc/captcha/image?v='+ Date.now();
        captcha.isValid = '';
        captcha.message = '';
        this.setState({
                    captcha: captcha
             });
    };

    handleIndividualValidation = (e) =>{

        //e.preventDefault();
        var state = this.state;
        console.log('re runinng validations here');
        //rerun the validations to make the appropriate messages appear
        this.validateNameResponse('firstName', this.state.firstName.value, state);
        this.validateNameResponse('lastName', this.state.lastName.value, state);
        this.validateEmailSyntaxResponse('email', this.state.email.value, state);
        this.validatePasswordResponse('password', this.state.password.value, state);
        this.setErrorFocus(state);
        this.scrollToError(state);
        if(!this.isIndividualPageValid()) {
            this.setState({
                genericFormLevelProblems: ['Please correct the issues in red below before continuing']
            });
        }
        return this.isIndividualPageValid();
    }


    handleCorporateValidation = (e) => {
        //e.preventDefault;
        var state = this.state;
        console.log('re runinng Corporate validations here');
        //rerun the validations to make the appropriate messages appear
        this.validateOrgNameResponse('orgName', this.state.orgName.value, state);
        if (!state.orgName.isAvailable) {
            this.checkIfOrgNameValidAndAvailableToContinue('orgName', this.state.orgName.value, state);
        }
        this.validateOrgSuccess('questionAndAnswerOrganizationTypeSelected', state);
        this.validateNameResponse('firstName', this.state.firstName.value, state);
        this.validateNameResponse('lastName', this.state.lastName.value, state);
        this.validateEmailSyntaxResponse('email', this.state.email.value, state);
        this.validatePasswordResponse('password', this.state.password.value, state);
        this.setErrorFocus(state);
        this.scrollToError(state);
        if(!this.isCorporatePageValid()) {
            this.setState({
                genericFormLevelProblems: ['Please correct the issues in red below before continuing']
            });
        }

        return this.isCorporatePageValid();
    }

    //Set Focus on error element and scroll to view
    //Set timeout so scrollToElement can find the elementfocus class in dom
    scrollToError = (state) => {
        setTimeout(() => {
            var elem = document.querySelector('.elementFocus');
            scrollToElement(elem, {
                offset: -200,
                duration: 100
            });
            if(elem){
                elem.focus();
            }
        }, 500);
    }

    setErrorFocus = (state) => {
        if(!state.orgName.isValid || !state.orgName.isAvailable){
            state.orgName.hasErrorFocus = true;
        } else {state.orgName.hasErrorFocus = false;}

    	if(!state.questionAndAnswerOrganizationTypeSelected.isValid){
            state.questionAndAnswerOrganizationTypeSelected.hasErrorFocus = true;
        } else {state.questionAndAnswerOrganizationTypeSelected.hasErrorFocus = false;}

        if(!state.firstName.isValid){
            state.firstName.hasErrorFocus = true;
        } else {state.firstName.hasErrorFocus = false;}

        if(!state.lastName.isValid){
            state.lastName.hasErrorFocus = true;
        } else {state.lastName.hasErrorFocus = false;}

        if(!state.email.isValid){
            state.email.hasErrorFocus = true;
        } else {state.email.hasErrorFocus = false;}

        if(!state.password.isValid){
            state.password.hasErrorFocus = true;
        } else {state.password.hasErrorFocus = false;}

        if(!state.phoneNumber.isValid){
            state.phoneNumber.hasErrorFocus = true;
        } else {state.phoneNumber.hasErrorFocus = false;}

        if(!state.address1.isValid){
            state.address1.hasErrorFocus = true;
        } else {state.address1.hasErrorFocus = false;}

        if(!state.city.isValid){
            state.city.hasErrorFocus = true;
        } else {state.city.hasErrorFocus = false;}

        if(!state.postalCode.isValid){
            state.postalCode.hasErrorFocus = true;
        } else {state.postalCode.hasErrorFocus = false;}

        if(!state.captcha.isValid){
            state.captcha.hasErrorFocus = true;
        } else {state.captcha.hasErrorFocus = false;}
    }

    isIndividualPageValid = () => {
        //this method exists as a health check that doesn't mutate state.
        const isValidToContinue = this.state.firstName.isValid &&
                                this.state.lastName.isValid &&
                                this.state.email.isValid &&
                                this.state.password.isValid;

        if(isValidToContinue === true){
            console.log('isIndividualPageValid ------------------' + true );
            return true;
        }
        else {
            console.log('isIndividualPageValid ------------------' + false );
            return false;
        }
    }

    isCorporatePageValid = () => {
        //this method exists as a health check that doesn't mutate state.
        const isValidToContinue = this.state.orgName.isValid &&
        						this.state.questionAndAnswerOrganizationTypeSelected.isValid &&
        						this.state.firstName.isValid &&
                                this.state.lastName.isValid &&
                                this.state.email.isValid &&
                                this.state.password.isValid;

        if(isValidToContinue === true){
            console.log('isCorporatePageValid ------------------' + true );
            return true;
        }
        else {
            console.log('isCorporatePageValid ------------------' + false );
            return false;
        }
    }

    /* this function is used to handle both Individual/Corporate TOS AKA Step two validations */
    handleValidationTermsOfService = (event) =>{
    	console.log("handle Individual/Corporate Validation TermsOfService.............." + event.target.value);

        var state = this.state;

        //rerun the validations to make the appropriate messages appear
        this.validatePhoneResponse('phoneNumber', this.state.phoneNumber.value, state);
        this.validateAddressResponse('address1', this.state.address1.value, state);
        this.validateCityResponse('city', this.state.city.value, state);
        this.setSelectedCountry(this.state.country.value);
        this.setSelectedState(this.state.stateProvince.value);
        this.validateZipcodeResponse('postalCode', this.state.postalCode.value, state);
        this.validateCaptchaResponse('captcha', this.state.captcha.value, state);


        this.setState({state});

        const isValidToContinue = this.state.phoneNumber.isValid &&
                                this.state.address1.isValid &&
                                this.state.city.isValid &&
                                this.state.postalCode.isValid &&
                                this.state.country.isValid &&
                                (this.state.stateProvince.isValid ||
                                this.state.nonUSState.isValid)  &&
                                this.state.captcha.isValid;

        if(!isValidToContinue){
            event.preventDefault();
            this.setState({
                          genericFormLevelProblems: ['Please correct the issues below before continuing']
                          });

        }

        this.setErrorFocus(state);
        this.scrollToError(state);

        return isValidToContinue;

    }

    setSelectedState = (selectedState) => {
        console.log("setSelectedState received callback from child for " + selectedState);

        var state = this.state;
        state.stateProvince.value = selectedState;

        if (selectedState === "Select" ) {
            state.stateProvince.isValid = false;
            state.stateProvince.message = "Error: Please select a State.";
        } else if (selectedState === "") {
            state.stateProvince.isValid = false;
            state.stateProvince.message = "Error: Please select a State.";
        } else{
            state.stateProvince.isValid = true;
            state.stateProvince.message = '';
        }

        this.setState({
            state
        });

     }

     setSelectedCountry = (selectedCountry) => {
        console.log("setSelectedCountry received callback from child " + selectedCountry);

        var state = this.state;
        state.country.value = selectedCountry;
        state.genericFormLevelProblems='';

        if (selectedCountry === "Select" || selectedCountry.includes("---") || selectedCountry === "") {
            state.country.isValid=false;
            state.country.message= "Error: Please select a Country.";
        } else if (selectedCountry === "UNITED STATES") {
            state.nonUSState.value = '';
            state.nonUSState.message = '';
            state.country.isValid = true;
            state.country.message = '';
            this.validateUSStateResponse('stateProvince', state.stateProvince.value, state);

        } else {
            //any other country
            state.country.isValid=true;
            state.country.message= '';
            this.validateNonUSStateResponse('nonUSState', state.nonUSState.value, state);
        }

        this.setState({
            state
        });

     }

    setSelectedNonUSState = (selectedNonUSState) => {
       console.log("setSelectedNonUSState received callback from child " + selectedNonUSState);

       var state = this.state;
       state.nonUSState.value = selectedNonUSState;

       state.genericFormLevelProblems='';
       this.validateNonUSStateResponse("nonUSState", selectedNonUSState, state);

       this.setState({
           state
       });
     }


  render() {
    //   console.log("Email valid is: " + this.state.email.isValid + "    Email value is: "+ this.state.email.value +
    //   "  Email message is: " + this.state.email.message)
      //questionAndAnswerContributionsSelectedOptions = {this.state.questionAndAnswerContributionsSelectedOptions}

    return(
        <Router>
            <div>
                <Switch>
                    <Redirect exact from="/" to="/select" push/>
                    <Route exact path="/select" component={SelectType}/>
                    <Route path="/individual">
                            <Individual
                                showLoader={this.state.showLoader}
                            	routeToTos={this.state.routeToTos}
                                firstName={this.state.firstName}
                                lastName={this.state.lastName}
                                email={this.state.email}
                                password={this.state.password}
                                newsletterSubscription={this.state.newsletterSubscription}
                                eventsSubscription={this.state.eventsSubscription}
                                questionAndAnswerContributionsQuestion = {this.state.questionAndAnswerContributionsQuestion}
                                questionAndAnswerContributionsPossibleOptions = {this.state.questionAndAnswerContributionsPossibleOptions}
                                questionAndAnswerContributionsSelectedOptions = {this.state.questionAndAnswerContributionsSelectedOptions}
                                questionAndAnswerFirstResponderQuestion = {this.state.questionAndAnswerFirstResponderQuestion}
                                questionAndAnswerFirstResponderPossibleAnswers = {this.state.questionAndAnswerFirstResponderPossibleAnswers}
                                questionAndAnswerFirstResponderAnswers = {this.state.questionAndAnswerFirstResponderAnswers}
                                genericFormLevelProblems={this.state.genericFormLevelProblems}
                                handleUserInput={this.handleUserInput}
                                handleIndividualValidation={this.handleIndividualValidation} />
                    </Route>

                    <Route path="/individualToS" >
                        <Loader loaded={!this.state.isCreateUserSubmitted}>
                                <IndividualToS
                                    phone={this.state.phoneNumber}
                                    country={this.state.country}
                                    usState={this.state.stateProvince}
                                    nonUSState={this.state.nonUSState}
                                    address={this.state.address1}
                                    city={this.state.city}
                                    zip={this.state.postalCode}
                                    genericFormLevelProblems={this.state.genericFormLevelProblems}
                                    captcha={this.state.captcha}
                                    userCreationSucceeded={this.state.userCreationSucceeded}
                                    handleUserInput={this.handleUserInput}
                                    handleSubmitIndividualUser={this.handleSubmitIndividualUser}
                                    refreshCaptcha={this.refreshCaptcha}
                                    setSelectedCountry={this.setSelectedCountry}
                                    setSelectedState={this.setSelectedState}
                                    setSelectedNonUSState={this.setSelectedNonUSState}
                                    isIndividualPageValid={this.isIndividualPageValid}
                                    handleValidationTermsOfService={this.handleValidationTermsOfService}
                                    showUSStatesDropdown={this.showUSStatesDropdown}
                                    />
                        </Loader>


                    </Route>
                    <Route path="/Corporate">
	                    <Corporate
		                    showLoader={this.state.showLoader}
                            routeToTos={this.state.routeToTos}
                            orgNameValid={this.state.orgNameValid}
	                    	orgName={this.state.orgName}
	                        firstName={this.state.firstName}
	                    	lastName={this.state.lastName}
	                    	email={this.state.email}
	                        password={this.state.password}
	                        newsletterSubscription={this.state.newsletterSubscription}
	                        eventsSubscription={this.state.eventsSubscription}
	                        questionAndAnswerContributionsQuestion = {this.state.questionAndAnswerContributionsQuestion}
	                        questionAndAnswerContributionsPossibleOptions = {this.state.questionAndAnswerContributionsPossibleOptions}
	                        questionAndAnswerContributionsSelectedOptions = {this.state.questionAndAnswerContributionsSelectedOptions}
	                        questionAndAnswerFirstResponderQuestion = {this.state.questionAndAnswerFirstResponderQuestion}
	                        questionAndAnswerFirstResponderPossibleAnswers = {this.state.questionAndAnswerFirstResponderPossibleAnswers}
	                        questionAndAnswerFirstResponderAnswers = {this.state.questionAndAnswerFirstResponderAnswers}
	                    	questionAndAnswerOrganizationTypeLabel = {this.state.questionAndAnswerOrganizationTypeLabel}
	                    	questionAndAnswerOrganizationTypes = {this.state.questionAndAnswerOrganizationTypes}
	                    	questionAndAnswerOrganizationTypeSelected = {this.state.questionAndAnswerOrganizationTypeSelected}
                            genericFormLevelProblems={this.state.genericFormLevelProblems}
                            checkIfOrgNameValidAndAvailableEvent={this.checkIfOrgNameValidAndAvailableEvent}
	                    	checkIfOrgNameValidAndAvailableToContinue={this.checkIfOrgNameValidAndAvailableToContinue}
	                        handleUserInput={this.handleUserInput}
	                    	handleCorporateValidation={this.handleCorporateValidation} />
                    </Route>
                    <Route path="/corporateToS" >
                        <Loader loaded={!this.state.isCreateUserSubmitted}>
                                <CorporateToS
                                    phone={this.state.phoneNumber}
                                    country={this.state.country}
                                    usState={this.state.stateProvince}
                                    nonUSState={this.state.nonUSState}
                                    address={this.state.address1}
                                    city={this.state.city}
                                    zip={this.state.postalCode}
                                    genericFormLevelProblems={this.state.genericFormLevelProblems}
                                    captcha={this.state.captcha}
                                    handleUserInput={this.handleUserInput}
                                    handleSubmit={this.handleSubmitCorporateUser}
                                    refreshCaptcha={this.refreshCaptcha}
                                    setSelectedCountry={this.setSelectedCountry}
                                    setSelectedState={this.setSelectedState}
                                    setSelectedNonUSState={this.setSelectedNonUSState}
                                	isCorporatePageValid={this.isCorporatePageValid}
                                    handleValidationTermsOfService={this.handleValidationTermsOfService}
                                    userCreationSucceeded={this.state.userCreationSucceeded}
                                	showUSStatesDropdown={this.showUSStatesDropdown}
                                    />
                        </Loader>

                    </Route>
                    <Route exact path="/confirmation" component={Confirmation}/>

                    <Route component={RouteNotFound404} />
                </Switch>
            </div>
        </Router>
        )
    }
  }

  export default RegistrationRouter;



// WEBPACK FOOTER //
// ./src/registration/RegistrationRouter.js